import React, {PureComponent} from 'react';
import './css/page404.css';

class Page404 extends PureComponent {
    render() {
        return (
            <div className="app">
                <div className="container-login">
                    <div className="error-page">
                        <div>
                            <h1 data-h1="404">404</h1>
                            <p data-p="NOT FOUND">NOT FOUND</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Page404;
